export default __webpack_public_path__ + "static/media/illu.b9ae5aed.jpg";